/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onTenantCreateContact = /* GraphQL */ `
  subscription OnTenantCreateContact($tenant: ID!) {
    onTenantCreateContact(tenant: $tenant) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      timeZone
      dnc
      updatedBy
      customFields
      expireDt
      complianceRequired
      preview
      outboundCallerId
      balances {
        id
        type
        amount
        age
      }
      type
      optout {
        Email
        SMS
        Voice
      }
      mobileDevices {
        type
        id
      }
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateContact = /* GraphQL */ `
  subscription OnTenantUpdateContact($tenant: ID!) {
    onTenantUpdateContact(tenant: $tenant) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      timeZone
      dnc
      updatedBy
      customFields
      expireDt
      complianceRequired
      preview
      outboundCallerId
      balances {
        id
        type
        amount
        age
      }
      type
      optout {
        Email
        SMS
        Voice
      }
      mobileDevices {
        type
        id
      }
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteContact = /* GraphQL */ `
  subscription OnTenantDeleteContact($tenant: ID!) {
    onTenantDeleteContact(tenant: $tenant) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      timeZone
      dnc
      updatedBy
      customFields
      expireDt
      complianceRequired
      preview
      outboundCallerId
      balances {
        id
        type
        amount
        age
      }
      type
      optout {
        Email
        SMS
        Voice
      }
      mobileDevices {
        type
        id
      }
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateSegment = /* GraphQL */ `
  subscription OnTenantCreateSegment($tenant: ID!) {
    onTenantCreateSegment(tenant: $tenant) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateSegment = /* GraphQL */ `
  subscription OnTenantUpdateSegment($tenant: ID!) {
    onTenantUpdateSegment(tenant: $tenant) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteSegment = /* GraphQL */ `
  subscription OnTenantDeleteSegment($tenant: ID!) {
    onTenantDeleteSegment(tenant: $tenant) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateActivityLog = /* GraphQL */ `
  subscription OnTenantCreateActivityLog($tenant: ID!) {
    onTenantCreateActivityLog(tenant: $tenant) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        timeZone
        dnc
        updatedBy
        customFields
        expireDt
        complianceRequired
        preview
        outboundCallerId
        balances {
          id
          type
          amount
          age
        }
        type
        optout {
          Email
          SMS
          Voice
        }
        mobileDevices {
          type
          id
        }
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            ratio
            paymentProfileId
            paymentProfileName
            defaultTimeZone
          }
          ai {
            org
            system
          }
          freshLIFO
          retryLIFO
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        resetOnCompletion
        static
        campaignSchedule
        segmentSchedule
        updatesEmail
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      c2aId
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onTenantUpdateActivityLog = /* GraphQL */ `
  subscription OnTenantUpdateActivityLog($tenant: ID!) {
    onTenantUpdateActivityLog(tenant: $tenant) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        timeZone
        dnc
        updatedBy
        customFields
        expireDt
        complianceRequired
        preview
        outboundCallerId
        balances {
          id
          type
          amount
          age
        }
        type
        optout {
          Email
          SMS
          Voice
        }
        mobileDevices {
          type
          id
        }
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            ratio
            paymentProfileId
            paymentProfileName
            defaultTimeZone
          }
          ai {
            org
            system
          }
          freshLIFO
          retryLIFO
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        resetOnCompletion
        static
        campaignSchedule
        segmentSchedule
        updatesEmail
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      c2aId
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onTenantDeleteActivityLog = /* GraphQL */ `
  subscription OnTenantDeleteActivityLog($tenant: ID!) {
    onTenantDeleteActivityLog(tenant: $tenant) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        timeZone
        dnc
        updatedBy
        customFields
        expireDt
        complianceRequired
        preview
        outboundCallerId
        balances {
          id
          type
          amount
          age
        }
        type
        optout {
          Email
          SMS
          Voice
        }
        mobileDevices {
          type
          id
        }
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            ratio
            paymentProfileId
            paymentProfileName
            defaultTimeZone
          }
          ai {
            org
            system
          }
          freshLIFO
          retryLIFO
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        resetOnCompletion
        static
        campaignSchedule
        segmentSchedule
        updatesEmail
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      c2aId
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onTenantCreateTenantSettings = /* GraphQL */ `
  subscription OnTenantCreateTenantSettings($id: ID!) {
    onTenantCreateTenantSettings(id: $id) {
      id
      icApp
      icVendor
      icBU
      icCluster
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      icAPIOverride
      icSMSMapping {
        enabled
        mappings {
          phone
          nicPocName
          nicPocGuid
          provider
          verified
          appKey
        }
      }
      icSMSProviderCredentials {
        provider
        data
        verified
      }
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      umaxConfig
      permanentCampaigns
      minimumSeats {
        productId
        minimumSeats
      }
      productSku {
        product
        productId
      }
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateTenantSettings = /* GraphQL */ `
  subscription OnTenantUpdateTenantSettings($id: ID!) {
    onTenantUpdateTenantSettings(id: $id) {
      id
      icApp
      icVendor
      icBU
      icCluster
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      icAPIOverride
      icSMSMapping {
        enabled
        mappings {
          phone
          nicPocName
          nicPocGuid
          provider
          verified
          appKey
        }
      }
      icSMSProviderCredentials {
        provider
        data
        verified
      }
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      umaxConfig
      permanentCampaigns
      minimumSeats {
        productId
        minimumSeats
      }
      productSku {
        product
        productId
      }
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteTenantSettings = /* GraphQL */ `
  subscription OnTenantDeleteTenantSettings($id: ID!) {
    onTenantDeleteTenantSettings(id: $id) {
      id
      icApp
      icVendor
      icBU
      icCluster
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      icAPIOverride
      icSMSMapping {
        enabled
        mappings {
          phone
          nicPocName
          nicPocGuid
          provider
          verified
          appKey
        }
      }
      icSMSProviderCredentials {
        provider
        data
        verified
      }
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      umaxConfig
      permanentCampaigns
      minimumSeats {
        productId
        minimumSeats
      }
      productSku {
        product
        productId
      }
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateCampaign = /* GraphQL */ `
  subscription OnTenantCreateCampaign($tenant: ID!) {
    onTenantCreateCampaign(tenant: $tenant) {
      id
      tenant
      name
      segments
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          ratio
          paymentProfileId
          paymentProfileName
          defaultTimeZone
        }
        ai {
          org
          system
        }
        freshLIFO
        retryLIFO
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      resetOnCompletion
      static
      campaignSchedule
      segmentSchedule
      updatesEmail
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateCampaign = /* GraphQL */ `
  subscription OnTenantUpdateCampaign($tenant: ID!) {
    onTenantUpdateCampaign(tenant: $tenant) {
      id
      tenant
      name
      segments
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          ratio
          paymentProfileId
          paymentProfileName
          defaultTimeZone
        }
        ai {
          org
          system
        }
        freshLIFO
        retryLIFO
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      resetOnCompletion
      static
      campaignSchedule
      segmentSchedule
      updatesEmail
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteCampaign = /* GraphQL */ `
  subscription OnTenantDeleteCampaign($tenant: ID!) {
    onTenantDeleteCampaign(tenant: $tenant) {
      id
      tenant
      name
      segments
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          ratio
          paymentProfileId
          paymentProfileName
          defaultTimeZone
        }
        ai {
          org
          system
        }
        freshLIFO
        retryLIFO
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      resetOnCompletion
      static
      campaignSchedule
      segmentSchedule
      updatesEmail
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateProfile = /* GraphQL */ `
  subscription OnTenantCreateProfile($tenant: ID!) {
    onTenantCreateProfile(tenant: $tenant) {
      id
      tenant
      name
      useAi
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        ratio
        paymentProfileId
        paymentProfileName
        defaultTimeZone
      }
      ai {
        org
        system
      }
      freshLIFO
      retryLIFO
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateProfile = /* GraphQL */ `
  subscription OnTenantUpdateProfile($tenant: ID!) {
    onTenantUpdateProfile(tenant: $tenant) {
      id
      tenant
      name
      useAi
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        ratio
        paymentProfileId
        paymentProfileName
        defaultTimeZone
      }
      ai {
        org
        system
      }
      freshLIFO
      retryLIFO
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteProfile = /* GraphQL */ `
  subscription OnTenantDeleteProfile($tenant: ID!) {
    onTenantDeleteProfile(tenant: $tenant) {
      id
      tenant
      name
      useAi
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        ratio
        paymentProfileId
        paymentProfileName
        defaultTimeZone
      }
      ai {
        org
        system
      }
      freshLIFO
      retryLIFO
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateDoNotCall = /* GraphQL */ `
  subscription OnTenantCreateDoNotCall($tenant: ID!) {
    onTenantCreateDoNotCall(tenant: $tenant) {
      id
      tenant
      phone
      sources
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateDoNotCall = /* GraphQL */ `
  subscription OnTenantUpdateDoNotCall($tenant: ID!) {
    onTenantUpdateDoNotCall(tenant: $tenant) {
      id
      tenant
      phone
      sources
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteDoNotCall = /* GraphQL */ `
  subscription OnTenantDeleteDoNotCall($tenant: ID!) {
    onTenantDeleteDoNotCall(tenant: $tenant) {
      id
      tenant
      phone
      sources
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateCampaignLog = /* GraphQL */ `
  subscription OnTenantCreateCampaignLog($tenant: ID!) {
    onTenantCreateCampaignLog(tenant: $tenant) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateCampaignLog = /* GraphQL */ `
  subscription OnTenantUpdateCampaignLog($tenant: ID!) {
    onTenantUpdateCampaignLog(tenant: $tenant) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteCampaignLog = /* GraphQL */ `
  subscription OnTenantDeleteCampaignLog($tenant: ID!) {
    onTenantDeleteCampaignLog(tenant: $tenant) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateConfigProfile = /* GraphQL */ `
  subscription OnTenantCreateConfigProfile($tenant: ID!) {
    onTenantCreateConfigProfile(tenant: $tenant) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      openClosed
      searchType
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      closeActivity
      loggingAction
      transferSkills
      uiInfo
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateConfigProfile = /* GraphQL */ `
  subscription OnTenantUpdateConfigProfile($tenant: ID!) {
    onTenantUpdateConfigProfile(tenant: $tenant) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      openClosed
      searchType
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      closeActivity
      loggingAction
      transferSkills
      uiInfo
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteConfigProfile = /* GraphQL */ `
  subscription OnTenantDeleteConfigProfile($tenant: ID!) {
    onTenantDeleteConfigProfile(tenant: $tenant) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      openClosed
      searchType
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      closeActivity
      loggingAction
      transferSkills
      uiInfo
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContact = /* GraphQL */ `
  subscription OnCreateContact($filter: ModelSubscriptionContactFilterInput) {
    onCreateContact(filter: $filter) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      timeZone
      dnc
      updatedBy
      customFields
      expireDt
      complianceRequired
      preview
      outboundCallerId
      balances {
        id
        type
        amount
        age
      }
      type
      optout {
        Email
        SMS
        Voice
      }
      mobileDevices {
        type
        id
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContact = /* GraphQL */ `
  subscription OnUpdateContact($filter: ModelSubscriptionContactFilterInput) {
    onUpdateContact(filter: $filter) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      timeZone
      dnc
      updatedBy
      customFields
      expireDt
      complianceRequired
      preview
      outboundCallerId
      balances {
        id
        type
        amount
        age
      }
      type
      optout {
        Email
        SMS
        Voice
      }
      mobileDevices {
        type
        id
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContact = /* GraphQL */ `
  subscription OnDeleteContact($filter: ModelSubscriptionContactFilterInput) {
    onDeleteContact(filter: $filter) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      timeZone
      dnc
      updatedBy
      customFields
      expireDt
      complianceRequired
      preview
      outboundCallerId
      balances {
        id
        type
        amount
        age
      }
      type
      optout {
        Email
        SMS
        Voice
      }
      mobileDevices {
        type
        id
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSegment = /* GraphQL */ `
  subscription OnCreateSegment($filter: ModelSubscriptionSegmentFilterInput) {
    onCreateSegment(filter: $filter) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSegment = /* GraphQL */ `
  subscription OnUpdateSegment($filter: ModelSubscriptionSegmentFilterInput) {
    onUpdateSegment(filter: $filter) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSegment = /* GraphQL */ `
  subscription OnDeleteSegment($filter: ModelSubscriptionSegmentFilterInput) {
    onDeleteSegment(filter: $filter) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      createdAt
      updatedAt
    }
  }
`;
export const onCreateActivityLog = /* GraphQL */ `
  subscription OnCreateActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onCreateActivityLog(filter: $filter) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        timeZone
        dnc
        updatedBy
        customFields
        expireDt
        complianceRequired
        preview
        outboundCallerId
        balances {
          id
          type
          amount
          age
        }
        type
        optout {
          Email
          SMS
          Voice
        }
        mobileDevices {
          type
          id
        }
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            ratio
            paymentProfileId
            paymentProfileName
            defaultTimeZone
          }
          ai {
            org
            system
          }
          freshLIFO
          retryLIFO
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        resetOnCompletion
        static
        campaignSchedule
        segmentSchedule
        updatesEmail
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      c2aId
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onUpdateActivityLog = /* GraphQL */ `
  subscription OnUpdateActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onUpdateActivityLog(filter: $filter) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        timeZone
        dnc
        updatedBy
        customFields
        expireDt
        complianceRequired
        preview
        outboundCallerId
        balances {
          id
          type
          amount
          age
        }
        type
        optout {
          Email
          SMS
          Voice
        }
        mobileDevices {
          type
          id
        }
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            ratio
            paymentProfileId
            paymentProfileName
            defaultTimeZone
          }
          ai {
            org
            system
          }
          freshLIFO
          retryLIFO
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        resetOnCompletion
        static
        campaignSchedule
        segmentSchedule
        updatesEmail
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      c2aId
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onDeleteActivityLog = /* GraphQL */ `
  subscription OnDeleteActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onDeleteActivityLog(filter: $filter) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        timeZone
        dnc
        updatedBy
        customFields
        expireDt
        complianceRequired
        preview
        outboundCallerId
        balances {
          id
          type
          amount
          age
        }
        type
        optout {
          Email
          SMS
          Voice
        }
        mobileDevices {
          type
          id
        }
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            ratio
            paymentProfileId
            paymentProfileName
            defaultTimeZone
          }
          ai {
            org
            system
          }
          freshLIFO
          retryLIFO
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        resetOnCompletion
        static
        campaignSchedule
        segmentSchedule
        updatesEmail
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      c2aId
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onCreateTenantSettings = /* GraphQL */ `
  subscription OnCreateTenantSettings(
    $filter: ModelSubscriptionTenantSettingsFilterInput
  ) {
    onCreateTenantSettings(filter: $filter) {
      id
      icApp
      icVendor
      icBU
      icCluster
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      icAPIOverride
      icSMSMapping {
        enabled
        mappings {
          phone
          nicPocName
          nicPocGuid
          provider
          verified
          appKey
        }
      }
      icSMSProviderCredentials {
        provider
        data
        verified
      }
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      umaxConfig
      permanentCampaigns
      minimumSeats {
        productId
        minimumSeats
      }
      productSku {
        product
        productId
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTenantSettings = /* GraphQL */ `
  subscription OnUpdateTenantSettings(
    $filter: ModelSubscriptionTenantSettingsFilterInput
  ) {
    onUpdateTenantSettings(filter: $filter) {
      id
      icApp
      icVendor
      icBU
      icCluster
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      icAPIOverride
      icSMSMapping {
        enabled
        mappings {
          phone
          nicPocName
          nicPocGuid
          provider
          verified
          appKey
        }
      }
      icSMSProviderCredentials {
        provider
        data
        verified
      }
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      umaxConfig
      permanentCampaigns
      minimumSeats {
        productId
        minimumSeats
      }
      productSku {
        product
        productId
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTenantSettings = /* GraphQL */ `
  subscription OnDeleteTenantSettings(
    $filter: ModelSubscriptionTenantSettingsFilterInput
  ) {
    onDeleteTenantSettings(filter: $filter) {
      id
      icApp
      icVendor
      icBU
      icCluster
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      icAPIOverride
      icSMSMapping {
        enabled
        mappings {
          phone
          nicPocName
          nicPocGuid
          provider
          verified
          appKey
        }
      }
      icSMSProviderCredentials {
        provider
        data
        verified
      }
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      umaxConfig
      permanentCampaigns
      minimumSeats {
        productId
        minimumSeats
      }
      productSku {
        product
        productId
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFtpImport = /* GraphQL */ `
  subscription OnCreateFtpImport(
    $filter: ModelSubscriptionFtpImportFilterInput
  ) {
    onCreateFtpImport(filter: $filter) {
      id
      tenant
      name
      host
      username
      password
      path
      privateKey
      port
      fieldMappingId
      lastCheck
      fileNameToSource
      algorithms {
        cipher
      }
      readyTimeout
      reportEmail
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateFtpImport = /* GraphQL */ `
  subscription OnUpdateFtpImport(
    $filter: ModelSubscriptionFtpImportFilterInput
  ) {
    onUpdateFtpImport(filter: $filter) {
      id
      tenant
      name
      host
      username
      password
      path
      privateKey
      port
      fieldMappingId
      lastCheck
      fileNameToSource
      algorithms {
        cipher
      }
      readyTimeout
      reportEmail
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteFtpImport = /* GraphQL */ `
  subscription OnDeleteFtpImport(
    $filter: ModelSubscriptionFtpImportFilterInput
  ) {
    onDeleteFtpImport(filter: $filter) {
      id
      tenant
      name
      host
      username
      password
      path
      privateKey
      port
      fieldMappingId
      lastCheck
      fileNameToSource
      algorithms {
        cipher
      }
      readyTimeout
      reportEmail
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCampaign = /* GraphQL */ `
  subscription OnCreateCampaign($filter: ModelSubscriptionCampaignFilterInput) {
    onCreateCampaign(filter: $filter) {
      id
      tenant
      name
      segments
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          ratio
          paymentProfileId
          paymentProfileName
          defaultTimeZone
        }
        ai {
          org
          system
        }
        freshLIFO
        retryLIFO
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      resetOnCompletion
      static
      campaignSchedule
      segmentSchedule
      updatesEmail
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCampaign = /* GraphQL */ `
  subscription OnUpdateCampaign($filter: ModelSubscriptionCampaignFilterInput) {
    onUpdateCampaign(filter: $filter) {
      id
      tenant
      name
      segments
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          ratio
          paymentProfileId
          paymentProfileName
          defaultTimeZone
        }
        ai {
          org
          system
        }
        freshLIFO
        retryLIFO
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      resetOnCompletion
      static
      campaignSchedule
      segmentSchedule
      updatesEmail
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCampaign = /* GraphQL */ `
  subscription OnDeleteCampaign($filter: ModelSubscriptionCampaignFilterInput) {
    onDeleteCampaign(filter: $filter) {
      id
      tenant
      name
      segments
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          ratio
          paymentProfileId
          paymentProfileName
          defaultTimeZone
        }
        ai {
          org
          system
        }
        freshLIFO
        retryLIFO
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      resetOnCompletion
      static
      campaignSchedule
      segmentSchedule
      updatesEmail
      createdAt
      updatedAt
    }
  }
`;
export const onCreateProfile = /* GraphQL */ `
  subscription OnCreateProfile($filter: ModelSubscriptionProfileFilterInput) {
    onCreateProfile(filter: $filter) {
      id
      tenant
      name
      useAi
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        ratio
        paymentProfileId
        paymentProfileName
        defaultTimeZone
      }
      ai {
        org
        system
      }
      freshLIFO
      retryLIFO
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProfile = /* GraphQL */ `
  subscription OnUpdateProfile($filter: ModelSubscriptionProfileFilterInput) {
    onUpdateProfile(filter: $filter) {
      id
      tenant
      name
      useAi
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        ratio
        paymentProfileId
        paymentProfileName
        defaultTimeZone
      }
      ai {
        org
        system
      }
      freshLIFO
      retryLIFO
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProfile = /* GraphQL */ `
  subscription OnDeleteProfile($filter: ModelSubscriptionProfileFilterInput) {
    onDeleteProfile(filter: $filter) {
      id
      tenant
      name
      useAi
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        ratio
        paymentProfileId
        paymentProfileName
        defaultTimeZone
      }
      ai {
        org
        system
      }
      freshLIFO
      retryLIFO
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDoNotCall = /* GraphQL */ `
  subscription OnCreateDoNotCall(
    $filter: ModelSubscriptionDoNotCallFilterInput
  ) {
    onCreateDoNotCall(filter: $filter) {
      id
      tenant
      phone
      sources
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDoNotCall = /* GraphQL */ `
  subscription OnUpdateDoNotCall(
    $filter: ModelSubscriptionDoNotCallFilterInput
  ) {
    onUpdateDoNotCall(filter: $filter) {
      id
      tenant
      phone
      sources
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDoNotCall = /* GraphQL */ `
  subscription OnDeleteDoNotCall(
    $filter: ModelSubscriptionDoNotCallFilterInput
  ) {
    onDeleteDoNotCall(filter: $filter) {
      id
      tenant
      phone
      sources
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCampaignLog = /* GraphQL */ `
  subscription OnCreateCampaignLog(
    $filter: ModelSubscriptionCampaignLogFilterInput
  ) {
    onCreateCampaignLog(filter: $filter) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCampaignLog = /* GraphQL */ `
  subscription OnUpdateCampaignLog(
    $filter: ModelSubscriptionCampaignLogFilterInput
  ) {
    onUpdateCampaignLog(filter: $filter) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCampaignLog = /* GraphQL */ `
  subscription OnDeleteCampaignLog(
    $filter: ModelSubscriptionCampaignLogFilterInput
  ) {
    onDeleteCampaignLog(filter: $filter) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onCreateConfigProfile = /* GraphQL */ `
  subscription OnCreateConfigProfile(
    $filter: ModelSubscriptionConfigProfileFilterInput
  ) {
    onCreateConfigProfile(filter: $filter) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      openClosed
      searchType
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      closeActivity
      loggingAction
      transferSkills
      uiInfo
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateConfigProfile = /* GraphQL */ `
  subscription OnUpdateConfigProfile(
    $filter: ModelSubscriptionConfigProfileFilterInput
  ) {
    onUpdateConfigProfile(filter: $filter) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      openClosed
      searchType
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      closeActivity
      loggingAction
      transferSkills
      uiInfo
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteConfigProfile = /* GraphQL */ `
  subscription OnDeleteConfigProfile(
    $filter: ModelSubscriptionConfigProfileFilterInput
  ) {
    onDeleteConfigProfile(filter: $filter) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      openClosed
      searchType
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      closeActivity
      loggingAction
      transferSkills
      uiInfo
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePreProcess = /* GraphQL */ `
  subscription OnCreatePreProcess(
    $filter: ModelSubscriptionPreProcessFilterInput
  ) {
    onCreatePreProcess(filter: $filter) {
      id
      tenant
      name
      action
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePreProcess = /* GraphQL */ `
  subscription OnUpdatePreProcess(
    $filter: ModelSubscriptionPreProcessFilterInput
  ) {
    onUpdatePreProcess(filter: $filter) {
      id
      tenant
      name
      action
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePreProcess = /* GraphQL */ `
  subscription OnDeletePreProcess(
    $filter: ModelSubscriptionPreProcessFilterInput
  ) {
    onDeletePreProcess(filter: $filter) {
      id
      tenant
      name
      action
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCIFLog = /* GraphQL */ `
  subscription OnCreateCIFLog($filter: ModelSubscriptionCIFLogFilterInput) {
    onCreateCIFLog(filter: $filter) {
      agentId
      tenant
      type
      metaData
      id
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCIFLog = /* GraphQL */ `
  subscription OnUpdateCIFLog($filter: ModelSubscriptionCIFLogFilterInput) {
    onUpdateCIFLog(filter: $filter) {
      agentId
      tenant
      type
      metaData
      id
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCIFLog = /* GraphQL */ `
  subscription OnDeleteCIFLog($filter: ModelSubscriptionCIFLogFilterInput) {
    onDeleteCIFLog(filter: $filter) {
      agentId
      tenant
      type
      metaData
      id
      createdAt
      updatedAt
    }
  }
`;
export const onCreateUMaxLog = /* GraphQL */ `
  subscription OnCreateUMaxLog($filter: ModelSubscriptionUMaxLogFilterInput) {
    onCreateUMaxLog(filter: $filter) {
      agentId
      tenant
      icBu
      type
      metaData
      id
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateUMaxLog = /* GraphQL */ `
  subscription OnUpdateUMaxLog($filter: ModelSubscriptionUMaxLogFilterInput) {
    onUpdateUMaxLog(filter: $filter) {
      agentId
      tenant
      icBu
      type
      metaData
      id
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteUMaxLog = /* GraphQL */ `
  subscription OnDeleteUMaxLog($filter: ModelSubscriptionUMaxLogFilterInput) {
    onDeleteUMaxLog(filter: $filter) {
      agentId
      tenant
      icBu
      type
      metaData
      id
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFieldsMapping = /* GraphQL */ `
  subscription OnCreateFieldsMapping(
    $filter: ModelSubscriptionFieldsMappingFilterInput
  ) {
    onCreateFieldsMapping(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateFieldsMapping = /* GraphQL */ `
  subscription OnUpdateFieldsMapping(
    $filter: ModelSubscriptionFieldsMappingFilterInput
  ) {
    onUpdateFieldsMapping(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteFieldsMapping = /* GraphQL */ `
  subscription OnDeleteFieldsMapping(
    $filter: ModelSubscriptionFieldsMappingFilterInput
  ) {
    onDeleteFieldsMapping(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDailyLicenseCount = /* GraphQL */ `
  subscription OnCreateDailyLicenseCount(
    $filter: ModelSubscriptionDailyLicenseCountFilterInput
  ) {
    onCreateDailyLicenseCount(filter: $filter) {
      id
      ownerTenant
      tenant
      cdProd
      ncProdNum
      ncBusinessUnit
      Date
      Count
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDailyLicenseCount = /* GraphQL */ `
  subscription OnUpdateDailyLicenseCount(
    $filter: ModelSubscriptionDailyLicenseCountFilterInput
  ) {
    onUpdateDailyLicenseCount(filter: $filter) {
      id
      ownerTenant
      tenant
      cdProd
      ncProdNum
      ncBusinessUnit
      Date
      Count
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDailyLicenseCount = /* GraphQL */ `
  subscription OnDeleteDailyLicenseCount(
    $filter: ModelSubscriptionDailyLicenseCountFilterInput
  ) {
    onDeleteDailyLicenseCount(filter: $filter) {
      id
      ownerTenant
      tenant
      cdProd
      ncProdNum
      ncBusinessUnit
      Date
      Count
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentProfile = /* GraphQL */ `
  subscription OnCreatePaymentProfile(
    $filter: ModelSubscriptionPaymentProfileFilterInput
  ) {
    onCreatePaymentProfile(filter: $filter) {
      id
      tenant
      name
      templateId
      vendorId
      apiKey
      descriptor
      ttl
      siteLogo
      header1
      header2
      sitePrimary
      siteSecondary
      minType
      minRate
      supportEmail
      supportPhone
      promptPaySkills
      channels
      c2a
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentProfile = /* GraphQL */ `
  subscription OnUpdatePaymentProfile(
    $filter: ModelSubscriptionPaymentProfileFilterInput
  ) {
    onUpdatePaymentProfile(filter: $filter) {
      id
      tenant
      name
      templateId
      vendorId
      apiKey
      descriptor
      ttl
      siteLogo
      header1
      header2
      sitePrimary
      siteSecondary
      minType
      minRate
      supportEmail
      supportPhone
      promptPaySkills
      channels
      c2a
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentProfile = /* GraphQL */ `
  subscription OnDeletePaymentProfile(
    $filter: ModelSubscriptionPaymentProfileFilterInput
  ) {
    onDeletePaymentProfile(filter: $filter) {
      id
      tenant
      name
      templateId
      vendorId
      apiKey
      descriptor
      ttl
      siteLogo
      header1
      header2
      sitePrimary
      siteSecondary
      minType
      minRate
      supportEmail
      supportPhone
      promptPaySkills
      channels
      c2a
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentTemplate = /* GraphQL */ `
  subscription OnCreatePaymentTemplate(
    $filter: ModelSubscriptionPaymentTemplateFilterInput
  ) {
    onCreatePaymentTemplate(filter: $filter) {
      id
      tenant
      name
      textBody
      type
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentTemplate = /* GraphQL */ `
  subscription OnUpdatePaymentTemplate(
    $filter: ModelSubscriptionPaymentTemplateFilterInput
  ) {
    onUpdatePaymentTemplate(filter: $filter) {
      id
      tenant
      name
      textBody
      type
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentTemplate = /* GraphQL */ `
  subscription OnDeletePaymentTemplate(
    $filter: ModelSubscriptionPaymentTemplateFilterInput
  ) {
    onDeletePaymentTemplate(filter: $filter) {
      id
      tenant
      name
      textBody
      type
      createdAt
      updatedAt
    }
  }
`;
export const onCreateWebhook = /* GraphQL */ `
  subscription OnCreateWebhook($filter: ModelSubscriptionWebhookFilterInput) {
    onCreateWebhook(filter: $filter) {
      id
      tenant
      event
      url
      auth
      apiToken
      apiTokenHeader
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateWebhook = /* GraphQL */ `
  subscription OnUpdateWebhook($filter: ModelSubscriptionWebhookFilterInput) {
    onUpdateWebhook(filter: $filter) {
      id
      tenant
      event
      url
      auth
      apiToken
      apiTokenHeader
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteWebhook = /* GraphQL */ `
  subscription OnDeleteWebhook($filter: ModelSubscriptionWebhookFilterInput) {
    onDeleteWebhook(filter: $filter) {
      id
      tenant
      event
      url
      auth
      apiToken
      apiTokenHeader
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCryptoPassport = /* GraphQL */ `
  subscription OnCreateCryptoPassport(
    $filter: ModelSubscriptionCryptoPassportFilterInput
  ) {
    onCreateCryptoPassport(filter: $filter) {
      id
      token
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCryptoPassport = /* GraphQL */ `
  subscription OnUpdateCryptoPassport(
    $filter: ModelSubscriptionCryptoPassportFilterInput
  ) {
    onUpdateCryptoPassport(filter: $filter) {
      id
      token
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCryptoPassport = /* GraphQL */ `
  subscription OnDeleteCryptoPassport(
    $filter: ModelSubscriptionCryptoPassportFilterInput
  ) {
    onDeleteCryptoPassport(filter: $filter) {
      id
      token
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onCreateRestConnection = /* GraphQL */ `
  subscription OnCreateRestConnection(
    $filter: ModelSubscriptionRestConnectionFilterInput
  ) {
    onCreateRestConnection(filter: $filter) {
      id
      tenant
      name
      endpoint
      method
      params {
        key
        value
        description
      }
      headers {
        key
        value
        description
      }
      auth {
        type
        info
      }
      enabled
      listPath
      mapping {
        from
        to
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateRestConnection = /* GraphQL */ `
  subscription OnUpdateRestConnection(
    $filter: ModelSubscriptionRestConnectionFilterInput
  ) {
    onUpdateRestConnection(filter: $filter) {
      id
      tenant
      name
      endpoint
      method
      params {
        key
        value
        description
      }
      headers {
        key
        value
        description
      }
      auth {
        type
        info
      }
      enabled
      listPath
      mapping {
        from
        to
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteRestConnection = /* GraphQL */ `
  subscription OnDeleteRestConnection(
    $filter: ModelSubscriptionRestConnectionFilterInput
  ) {
    onDeleteRestConnection(filter: $filter) {
      id
      tenant
      name
      endpoint
      method
      params {
        key
        value
        description
      }
      headers {
        key
        value
        description
      }
      auth {
        type
        info
      }
      enabled
      listPath
      mapping {
        from
        to
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateMobileConfiguration = /* GraphQL */ `
  subscription OnCreateMobileConfiguration(
    $filter: ModelSubscriptionMobileConfigurationFilterInput
  ) {
    onCreateMobileConfiguration(filter: $filter) {
      id
      tenant
      name
      description
      projectId
      androidEnabled
      iosEnabled
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateMobileConfiguration = /* GraphQL */ `
  subscription OnUpdateMobileConfiguration(
    $filter: ModelSubscriptionMobileConfigurationFilterInput
  ) {
    onUpdateMobileConfiguration(filter: $filter) {
      id
      tenant
      name
      description
      projectId
      androidEnabled
      iosEnabled
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteMobileConfiguration = /* GraphQL */ `
  subscription OnDeleteMobileConfiguration(
    $filter: ModelSubscriptionMobileConfigurationFilterInput
  ) {
    onDeleteMobileConfiguration(filter: $filter) {
      id
      tenant
      name
      description
      projectId
      androidEnabled
      iosEnabled
      createdAt
      updatedAt
    }
  }
`;
